import { getUserPhotoSrc } from 'core/functions';

const trimTrailingSlashes = (value: string) => value.replace(/\/+$/, '');
const trimLeadingSlashes = (value: string) => value.replace(/^\/+/, '');

const getS3Prefix = () => {
	const base = process.env.REACT_APP_S3_API;
	return base ? trimTrailingSlashes(base) : '';
};

export const normalizePostImageForPreview = (imagePath?: string | null) => {
	if (!imagePath || !imagePath.trim()) return '';
	return getUserPhotoSrc(imagePath);
};

export const mapPostImageToPayload = (imagePath?: string | null) => {
	if (!imagePath) return undefined;

	const normalizedImagePath = imagePath.trim();
	if (!normalizedImagePath) return undefined;

	const s3Prefix = getS3Prefix();
	if (!s3Prefix) return normalizedImagePath;

	const prefixedS3Path = `${s3Prefix}/`;
	if (normalizedImagePath.startsWith(prefixedS3Path)) {
		return trimLeadingSlashes(normalizedImagePath.slice(prefixedS3Path.length));
	}

	return normalizedImagePath;
};
